export default {"src":"/_next/static/media/payment-visa.28e75133.svg","height":30,"width":45,"blurWidth":0,"blurHeight":0};